import { Component, Input, Output, EventEmitter } from '@angular/core';
import { colorsByStatus } from '../../store/performers.era';
import { Wrapper } from '../wrapper.component';
import { hasProgramPermissionsReselector } from '../../store/reselectors/permissions.reselector';
import { OnInit } from '@angular/core';
import { Program, Session, SessionContentStatus } from 'globals/store/programs.data';
import { TrafficLightComponent } from '../misc/traffic-light.component';
import { TrafficLightDropdownComponent } from '../misc/traffic-light-dropdown.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'session-status',
    template: `
<traffic-light *ngIf="dotOnly" [color]="colorsByStatus[status]"></traffic-light>
<traffic-light-dropdown
  *ngIf="!dotOnly"
  [selected]="status"
  [colorObject]="colorsByStatus"
  [selections]="statusOptions"
  [readOnly]="readOnly || !hasPermission"
  (select)="setSessionStatus($event)"
></traffic-light-dropdown>
`,
    styles: [`

`],
    standalone: true,
    imports: [TrafficLightComponent, CommonModule, TrafficLightDropdownComponent],
})
export class SessionStatusComponent extends Wrapper<SessionStatusComponent> implements OnInit {
  @Input() dotOnly = true
  @Input() programId: string
  @Input() sessionId: string
  @Input() readOnly = false

  hasPermission = false

  program: Program
  session: Session
  statusOptions: SessionContentStatus[] = ['Not Confirmed','In Progress','Confirmed','Review']
  status: SessionContentStatus
  colorsByStatus = colorsByStatus
  @Output() changeStatus: EventEmitter<SessionContentStatus> = new EventEmitter()

  constructor() {
    super()
  }

  ngOnInit() {
    this.selectProp(hasProgramPermissionsReselector, null, 'hasPermission')
    this.subCallback(this.store.select('programs', 'entities'), (programs) => {
      this.program = programs[this.programId];
      this.session = this.program.sessions_obj[this.sessionId];
      this.status = this.session.contentStatus || 'Not Confirmed';
    })
    
  }

  setSessionStatus(status: string) {
    this.session.contentStatus = status as SessionContentStatus
    console.log({status: status});
    this.programService.updateSession(this.programId, this.session)
  }
  
}



